
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { Component, Prop, Vue } from 'vue-property-decorator';

dayjs.extend(relativeTime);

@Component({
  name: 'timeago',
})
export default class TimeAgo extends Vue {
  @Prop({ required: true })
  datetime!: string | number | Date;

  @Prop({ type: [String, Boolean], default: true })
  title!: string | boolean;

  timeago = '';

  private updateInterval: ReturnType<typeof setInterval> | null = null;

  get isoDatetime(): string {
    return new Date(this.datetime).toISOString();
  }

  get titleValue(): string | undefined {
    if (this.title === false) return undefined;
    if (typeof this.title === 'string') return this.title;
    return this.timeago;
  }

  updateTimeago() {
    this.timeago = dayjs(this.datetime).fromNow();
  }

  mounted() {
    this.updateTimeago();
    this.updateInterval = setInterval(() => {
      this.updateTimeago();
    }, 60000);
  }

  beforeDestroy() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  }
}
